import { each } from 'lodash';
import { getLinesCount } from "../common/statistics";
import {
  allPlansInclude, planFeatures,
  perkTitles, perkFeatures,
  perksSectionTitle, perksSectionText,
  pricingLinesDescription,
  linesEmptyPlanTitle
} from '../common/common_data';

const pricing = [
  [ 70, 60, 45, 35, 30 ],
  [ 80, 70, 55, 45, 40 ],
  [ 90, 80, 65, 55, 50 ]
];

const priceForLine = (planId) => {
  if (!planId) {
    return null;
  }
  return pricing[planId - 1][getLinesCount() - 1];
};

const planA = {
  id: 1,
  name: "Plan A",
  features: [
    { ...planFeatures.Unlimited5G, ...{ klass: '-two-lines-description' } },
    planFeatures.Get400ToNewPhone
  ],
  perksCount: 0
};

const planB = {
  id: 2,
  name: "Plan B",
  features: [
    { ...planFeatures.Unlimited5GUltra, ...{ klass: '-two-lines-description' } },
    planFeatures.Get800ToNewPhone,
    planFeatures.plusPerks(1)
  ],
  choosePerks: planFeatures.choosePerks(1),
  perksCount: 1
};

const planC = {
  id: 3,
  name: "Plan C",
  features: [
    { ...planFeatures.Unlimited5GUltra, ...{ klass: '-two-lines-description' } },
    planFeatures.Get800ToNewPhone,
    planFeatures.plusPerks(2)
  ],
  choosePerks: planFeatures.choosePerks(2),
  perksCount: 2
};


const entertainmentPerk = {
  id: 1,
  list: [
    perkFeatures.DisneyBundle
  ]
};

const entertainmentStorePerk = {
  id: 2,
  list: [
    perkFeatures.EntertainmentStore
  ]
};

const musicPerk = {
  id: 3,
  list: [
    perkFeatures.AppleMusic
  ]
};

const gamingPerk = {
  id: 4,
  list: [
    perkFeatures.GameXBox,
    perkFeatures.GameArcade
  ]
};

const globalCallingPerk = {
  id: 5,
  list: [
    perkFeatures.GlobalCalling
  ]
};

const internationalRoamingPerk = {
  id: 6,
  list: [
    perkFeatures.Roaming
  ]
};

const workAnywherePerk = {
  id: 7,
  list: [
    perkFeatures.AnyWhereMobile,
    perkFeatures.AnyWhereWatch
  ]
};

const securityPerk = {
  id: 8,
  list: [
    perkFeatures.SecurityMCAfee,
    perkFeatures.SecurityRing,
    perkFeatures.SecurityVerizon
  ]
};

const homeInternetPerk = {
  id: 9,
  list: [
    perkFeatures.HomeInternet25
  ]
};

const plans = [
  planA,
  planB,
  planC
].map((el) => ({
  ...el,
  get price() { return pricing[this.id - 1][getLinesCount() - 1]; }
}));

const perkList = [
  entertainmentPerk,
  entertainmentStorePerk,
  musicPerk,
  gamingPerk,
  globalCallingPerk,
  internationalRoamingPerk,
  workAnywherePerk,
  securityPerk,
  homeInternetPerk
];
each(perkList, (item, index) => {
  item.title = perkTitles[index];
});

const cell8 = {
  plans,
  getPlanPriceByLine: (plan, currentLine) => (plan.price),
  allPlansInclude, pricing,
  perks: perkList,
  perksSectionTitle,
  perksSectionText,
  linesDescription: pricingLinesDescription,
  linesEmptyPlanTitle
};

export { cell8, priceForLine  };
